import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Table,
  Switch,
  Pagination,
  message,
  Button,
  Select,
  Empty,
} from "antd";
import moment from "moment";
import "moment/locale/pt-br";
import Loading from "../../../../components/Loading";
import Drawer from "./drawerFilter";
import { getListCfop, putCfop } from "./actions";
import { createLoadingSelector } from "../../../../store/api/selectors";
moment.locale("pt-br");

const Option = Select.Option;

const initialState = {
  selectedConsider: null,
  list: [],
  filter: {
    sCodigo: null,
    sDataInicio: null,
    sDataFim: null,
    sConsiderarReceita: null,
    sorter: null,
  },
};

class Cfop extends Component {
  constructor(props) {
    super(props);

    const icmsModule = sessionStorage.getItem("icmsModule");

    this.state = {
      ...initialState,
      sizePage: 50,
      paginationStr: "",
      filterStr: "",
      visibleDrawer: false,
      icmsModule: icmsModule,
    };

    this.handleReset = this.handleReset.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.setState(
      {
        paginationStr: `?pageNumber=1&pageSize=${this.state.sizePage}&filter=`,
      },
      () => {
        this.props.getListCfop(this.state.filterStr);
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.props.cnpj !== prevProps.cnpj){
      this.setState(
        {
          paginationStr: `?pageNumber=1&pageSize=${this.state.sizePage}&filter=`,
          filterStr: "",
          filter: {...initialState.filter}
        },
        () => {
          this.props.getListCfop(this.state.filterStr);
        }
      );
    }else{
      if (this.props.status === 200) {
        message.success("CFOP editado com sucesso");
        this.props.getListCfop();
      }
      if(this.props.list !== this.state.list){
        this.setState({ list: this.props.list });
      }
    }
   
  }

  handleReset() {
    this.setState({ ...initialState });
  }

  changePage = (page) => {
    const { filterStr, sizePage } = this.state;

    this.setState(
      {
        paginationStr: `?pageNumber=${page}&pageSize=${sizePage}&filter=${filterStr}`,
      },
      () => {
        this.props.getListCfop(this.state.paginationStr);
      }
    );
  };

  changeSizePage = (current, size) => {
    const { filterStr } = this.state;

    this.setState(
      {
        sizePage: size,
        paginationStr: `?pageNumber=${current}&pageSize=${size}&filter=${filterStr}`,
      },
      () => {
        this.props.getListCfop(this.state.paginationStr);
      }
    );
  };

  handleFilters = () => {
    const { filter, sizePage } = this.state;
    let filterStr = "";

    Object.keys(filter).map((item) => {
      if (filter[item]) {
        if (filterStr) {
          filterStr = filterStr + "|" + item + filter[item];
        } else {
          filterStr = filterStr + item + filter[item];
        }
      }
      filterStr = filterStr.replace("sorter", "");
      return filterStr;
    });

    this.setState(
      {
        filterStr: filterStr,
        paginationStr: `?pageNumber=1&pageSize=${sizePage}&filter=`,
      },
      () => {
        filterStr = this.state.paginationStr + filterStr;
        this.props.getListCfop(filterStr);
      }
    );
  };

  handleChangeSorter = (pagination, filters, sorter) => {
    let sort = "";

    if (sorter.order) {
      const order = sorter.order === "ascend" ? 0 : 1;
      sort = sorter.field ? "o" + sorter.field + "=" + order : "";
    }

    this.setState(
      {
        filter: {
          ...this.state.filter,
          sorter: sort,
        },
      },
      () => {
        this.handleFilters();
      }
    );
  };

  handleChangeField = (e, field) => {
    const name = field ? field : e.target.name;
    let value = field ? e : e.target.value;

    if (name === "Codigo") {
      value = value.replace(/[^\d]+/g,'')
    }

    this.setState({
      filter: {
        ...this.state.filter,
        ["s" + name]: value !== null ? `=${value}` : null,
      },
    });

    if (field === "ConsiderarReceita") {
      this.setState({ selectedConsider: value });
    }
  };

  handleChange = (e, record, isSwitch) => {
    let newRecord;
    this.props.list.filter((item) => {
      return item.Codigo === record.Codigo ? (newRecord = item) : null;
    });
    if (isSwitch) newRecord.ConsiderarReceita = e;
    else newRecord.Status = e;
    this.props.putCfop(newRecord);
  };

  showDrawer = () => {
    this.setState({ visibleDrawer: true });
  };

  onClose = () => {
    this.setState({ visibleDrawer: false });
  };

  render() {
    const { paging, isFetching, desabilitarOpcoesConfiguracao} = this.props;
    const { visibleDrawer, filterStr, list } = this.state;

    let columns = [
      {
        title: "Código",
        dataIndex: "Codigo",
        width: 90,
        align: "center",
        sorter: true,
      },
      {
        title: "Descricao",
        dataIndex: "Descricao",
        width: 360,
      },
      {
        title: "Considera receita",
        dataIndex: "ConsiderarReceita",
        width: 150,
        align: "center",
        sorter: true,
        render: (text, record) => (
          <Switch
            disabled={desabilitarOpcoesConfiguracao}
            defaultChecked={record.ConsiderarReceita}
            checkedChildren="Sim"
            unCheckedChildren="Não"
            onChange={(e) => this.handleChange(e, record, true)}
          />
        ),
      },
      {
        title: "Tributação ICMS",
        dataIndex: "Status",
        width: 290,
        align: "center",
        sorter: true,
        render: (text, record) => (
          <Select
            disabled={desabilitarOpcoesConfiguracao}
            className="ant-select--custom"
            defaultValue={record.Status}
            style={{ width: 290 }}
            onChange={(e) => this.handleChange(e, record, false)}
          >
            <Option value={0}>Indefinido</Option>
            <Option value={1}>ICMS/ST</Option>
            <Option value={2}>Tributado</Option>
            <Option value={3}>Antecipação com encerramento do ICMS</Option>
          </Select>
        ),
      },
    ];

    // Ocultar coluna Tributação ICMS no módulo 2
    if (this.state.icmsModule && columns) {
      columns = columns.filter((x) => x.dataIndex !== "Status");
    }

    const newList =
      list &&
      list.map((item) => {
        return {
          ...item,
          DataInicio: moment(item.DataInicio).format("L"),
          DataFim:
            moment(item.DataFim).format("L") !== "01/01/0001"
              ? moment(item.DataFim).format("L")
              : "-",
        };
      });

    return (
      <>
        {isFetching ? <Loading /> : null}
        <Drawer
          {...this.state}
          visibleDrawer={visibleDrawer}
          handleChangeField={this.handleChangeField}
          handleFilters={this.handleFilters}
          handleReset={this.handleReset}
          onClose={this.onClose}
        />

        {newList.length ? (
          <>
            <div className="d-flex justify-content-end pb-2">
              <Button className="btn" icon="filter" onClick={this.showDrawer}>
                Filtrar
              </Button>
            </div>

            <Table
              className="ant-table--custom"
              columns={columns}
              dataSource={[...newList]}
              rowKey={(record) => `${record.Codigo}${Math.random()}`}
              pagination={false}
              key={`table-cfop-${Math.random()}`}
              scroll={{ y: "calc(100vh - 410px)", x: "800px" }}
              onChange={this.handleChangeSorter}
            />

            {paging ? (
              <Pagination
                className="mt-3"
                showSizeChanger
                pageSizeOptions={["10", "50", "100"]}
                defaultPageSize={50}
                defaultCurrent={1}
                total={paging && paging.TotalItems}
                showTotal={(total, range) =>
                  `${range[0]}-${range[1]} de ${total} itens`
                }
                onChange={this.changePage}
                onShowSizeChange={this.changeSizePage}
              />
            ) : null}
          </>
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Nenhum CFOP para mostrar"
          >
            {filterStr !== "" ? (
              <Button className="btn" icon="filter" onClick={this.showDrawer}>
                Filtrar
              </Button>
            ) : null}
          </Empty>
        )}
      </>
    );
  }
}

const getCfopLoading = createLoadingSelector(["GET_LIST_CFOP"]);
const putCfopLoading = createLoadingSelector(["PUT_CFOP"]);
const mapStateToProps = (state) => ({
  list: state.cfop.list,
  paging: state.cfop.paging,
  status: state.cfop.status,
  isFetching: getCfopLoading(state) || putCfopLoading(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getListCfop, putCfop }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Cfop);
